<template>
  <div>
    <el-page-header class="page-header" title="返回" @back="goBack" content="接待人员列表"></el-page-header>
    <div class="help">
      <p>
        添加公司固定的人为接待人员，当添加多个人员的时候，只能设置一个接收人员。
      </p>
    </div>
    
    <div class="container Mmain">
      <div class="header-menu">
      <div class="menu-left">
        <el-button type="primary" icon="el-icon-plus" @click="addContact">添加</el-button>
        <el-button type="danger" @click="handleDelete">删除</el-button>
        <el-button type="primary" icon="el-icon-refresh" :loading="updateLoading" @click="getRenew">同步</el-button>
      </div>
    </div>
      <el-table :data="tableData" border  @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="名称" prop="name" width="240"></el-table-column>
        <el-table-column label="头像" prop="avatar">
          <template slot-scope="scope">
            <el-image style="width: 4rem; height: 4rem" :src="scope.row.avatar" :preview-src-list="[scope.row.avatar]"
              fit="scale-down"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status_name" width="240"></el-table-column>
        <el-table-column label="是否为接收人员" prop="assign_name" width="240"></el-table-column>
        <el-table-column label="创建时间" width="300">
          <template slot-scope="scope">
            <span style="margin-left: 1rem">{{ scope.row.createtime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="170">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="onSet(scope.row)" v-if="scope.row.assign == 0">设为接收员</el-button>
            <el-button type="text" style="color:#f00 !important" size="mini" @click="cancelSet(scope.row)" v-else>取消接收</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" :page-sizes="[10, 20, 50, 100]"
        @pagination="getList" />
    </div>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import pagination from "@/components/Pagination";
import rightPeople from '@/components/drawer/rightPeople';

export default {
  name: "receptionStaffList",
  components: {
    pagination,
    rightPeople
  },
  data() {
    return {
      baseURL: this.axios.defaults.baseURL,
      total: 0,
      tableData: [],
      listQuery: {
        page: 1,
        limit: 20,
      },
      tooken: "",
      searchVal: "",
      formLabelWidth: "8rem",
      open_kfid: "", //客服列表跳转过来的open_kfid
      updateLoading: false,
      userid_list: [], //删除时的userid-list
      uid_list: [], //添加时的userid-list
      checkbox: false,
      module: "",
    };
  },

  computed: {},

  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.open_kfid = localStorage.getItem("open_kfid");
    this.getList();
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    getList() {
      this.axios
        .post(
          "/crm/CustomerService/getReceptionistList",
          qs.stringify({
            account_id: this.tooken.account_id,
            open_kfid: this.open_kfid,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            show: "userid",
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.tableData = res.data.data;
            this.total = res.data.count;
            
          } else if (res.data.code == 0) {
            this.tableData = [];
            this.total = res.data.count;
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    onSearch() { },
    handleDelete() {
      this.$confirm("确定删除选中的接待人员吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/CustomerService/deleteReceptionist",
              qs.stringify({
                account_id: this.tooken.account_id,
                open_kfid: this.open_kfid,
                userid_list: this.userid_list.toString(),
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.getList();
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async addReceptionist() {
      const res = await this.axios({
        url: "/crm/CustomerService/addReceptionist",
        method: "POST",
        data: {
          account_id: this.tooken.account_id,
          open_kfid: this.open_kfid,
          userid_list: this.uid_list,
        },
      });
      if (res.data.code == 1) {
        this.$message({
          message: "添加成功",
          type: "success",
        });
        this.getList();
      } else {
        this.$message({
          message: res.data.msg,
          type: "fail",
        });
      }
    },
    async getRenew() {
      this.updateLoading = true;
      // 拉取更新数据
      const res = await this.axios({
        url: "/crm/CustomerService/updateReceptionist",
        method: "POST",
        data: {
          account_id: this.tooken.account_id,
          open_kfid: this.open_kfid,
        },
      });
      if (res.data.code == 1) {
        this.getList();
        this.updateLoading = false;
        this.$message({
                  message: res.data.msg,
                  type: "success",
                });
      } else {
        this.$message({
          message: res.data.msg,
          type: "fail",
        });
      }
    },
    handleSelectionChange(val) {
      this.userid_list = val.map((value) => {
        return value.userid;
      });
    },
    addContact() {
      this.module = "getAddressBook";
      this.checkbox = true;
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      const userid = [];
      const user = [];
      switch (this.module) {
        case "getAddressBook":
          person.map((item) => {
            userid.push(item.userid);
            user.push(item.name);
          });
          this.uid_list = userid.join();
          break;
        default:
          break;
      }
      this.addReceptionist();
    },
    onSet(e) {
      this.$confirm("确定将选中人员设为接收人员吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/CustomerService/setReception",
              qs.stringify({
                account_id: this.tooken.account_id,
                open_kfid: e.open_kfid,
                userid: e.userid,
                assign: "1",
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.getList();
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    cancelSet(e) {
      this.$confirm("确定取消此接收人员吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/CustomerService/setReception",
              qs.stringify({
                account_id: this.tooken.account_id,
                open_kfid: e.open_kfid,
                userid: e.userid,
                assign: "0",
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.getList();
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
};
</script>
<style  scoped>
.help{padding: 2rem;
  margin-bottom:2rem;
  border-radius: 1rem;
}
.Mmain{
  background-color: #fff;
  border-radius: .8rem;
  padding: 3rem;
}
</style>